import dayjs from '../../libs/dayjs'
import { cnpjCpfMask, parseDate } from '../../utils/masks'

import { TableReceivedRecurrences } from './styles'
interface Props {
    receivedRecurrences: never[]
}
const ReceivedByYou = ({ receivedRecurrences }: Props) => {
    function renderRowsReceivedRecurrences() {
        return receivedRecurrences.map((recurrence: any) => {
            return (
                <tr key={recurrence.id}>
                    <td>
                        {dayjs(recurrence.createdAt).format(
                            'DD/MM/YYYY HH:mm:ss'
                        )}
                    </td>
                    <td>{recurrence.nomePagador}</td>
                    <td>{cnpjCpfMask(recurrence.cnpjPagador)}</td>
                    <td>{parseDate(recurrence.data_liquidacao_atual, true)}</td>
                    <td>
                        {Number(recurrence.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                    <td>{recurrence.situacao}</td>
                </tr>
            )
        })
    }
    return (
        <TableReceivedRecurrences>
            <thead>
                <tr>
                    <th>Data de criação</th>
                    <th>Pagador</th>
                    <th>
                        CPF/CNPJ <br />
                        (Quem te enviou)
                    </th>
                    <th>Próxima liquidação</th>
                    <th>Valor</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody>{renderRowsReceivedRecurrences()}</tbody>
        </TableReceivedRecurrences>
    )
}

export default ReceivedByYou
